import axiosInstance from "../axios_instance";

export async function getModuleStatsOverall(body) {
  try {
    return await axiosInstance.post(`reports/get-modulewise-overallcount`, body);
  } catch (error) {
    return error;
  }
}
